export default __webpack_public_path__ + "static/media/fbank-valuation-graph1.29dc6619.jpg";